import { LuSparkles  , LuHeartHandshake,  LuLineChart, LuStore } from "react-icons/lu";

const MelhorQueEcommerceSection = () => {
  return (
    <section className="py-24 px-6 sm:px-12 text-gray-900">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Texto provocativo */}
        <div className="text-center lg:text-left">
          <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-800/80">
            Melhor que e-commerce
          </h3>
          <h2 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight leading-tight text-gray-900">
            A experiência de compra acontece na loja — não num carrinho virtual
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-800/90 max-w-xl mx-auto lg:mx-0">
            Seu cliente quer chegar na loja com desejo e sair com a sacola na
            mão. Quem se desloca até o ponto físico deseja viver uma
            experiência — e disposto a levar um produto com maior valor
            agregado.
            <br className="hidden sm:block" />O mar vermelho do e-commerce é um
            risco para o lojista, não uma solução. Lá, o menor preço sempre
            vence. A Vintree faz diferente: qualifica o interesse, agiliza o
            atendimento e prepara o terreno para a venda acontecer onde ela é
            mais forte — dentro da sua loja.
          </p>
        </div>

        {/* Elemento gráfico */}
        <div className="grid grid-cols-2 gap-6 max-w-md mx-auto">
          <div className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm text-center">
            <LuSparkles className="w-7 h-7 text-pink-500 mx-auto mb-3" />
            <h4 className="text-lg font-semibold text-gray-900">
              Atendimento inteligente
            </h4>
            <p className="text-sm mt-2 text-gray-600">
              Você já sabe o que o cliente quer na hora que ele entra em contato.
            </p>
          </div>

          <div className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm text-center">
            <LuHeartHandshake  className="w-7 h-7 text-indigo-500 mx-auto mb-3" />
            <h4 className="text-lg font-semibold text-gray-900">Sem fricção</h4>
            <p className="text-sm mt-2 text-gray-600">
              Nada de login, senha ou carrinho. É ver, gostar e chamar.
            </p>
          </div>

          <div className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm text-center">
            <LuLineChart className="w-7 h-7 text-yellow-500 mx-auto mb-3" />
            <h4 className="text-lg font-semibold text-gray-900">
              Mais controle
            </h4>
            <p className="text-sm mt-2 text-gray-600">
              Descubra o que chamou atenção e melhore sua vitrine.
            </p>
          </div>

          <div className="bg-white border border-gray-200 p-5 rounded-2xl shadow-sm text-center">
            <LuStore className="w-7 h-7 text-green-600 mx-auto mb-3" />
            <h4 className="text-lg font-semibold text-gray-900">
              Foco na loja física
            </h4>
            <p className="text-sm mt-2 text-gray-600">
              Converte interesse digital em vendas reais no seu espaço.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MelhorQueEcommerceSection;
